import { MachineContext } from 'contexts/machine.context';
import { useContext, useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import useListLibraryStore from 'stores/use-list-library-store';

const useRefreshLists = () => {
  const current = useAuthStore((s) => s.current);
  const userRoleFeatureFlags = useAuthStore((s) => s.userRoleFeatureFlags);
  const { machine } = useContext(MachineContext);

  useEffect(() => {
    if (!current.auth) {
      return;
    }

    useListLibraryStore.getState().refreshLists(false);
  }, [
    current.auth, // login complete, calls will be authenticated
    current.session, // detect special session mode, reload data to match user's access

    current.team_lists, // access to team lists
    current.machine_lists, // access to machine lists

    userRoleFeatureFlags,

    machine.machineID,
    machine.ball_type, // todo: does this really need to trigger a refresh anymore?
  ]);
};

export default useRefreshLists;
